<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other"></i>
        新增CRT点位地址表
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="点位类型" prop="point_type" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <!-- <el-input v-model="form.name" placeholder="请输入"></el-input> -->
            <vselect :id="176" :value.sync="form.point_type" :filterable="true"></vselect>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item
            label="系统类型"
            prop="system_type"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <vselect
              :id="211"
              :value.sync="form.system_type"
              :filterable="true"
            ></vselect>
          </el-form-item>
        </el-col> -->

        <!-- <el-col :span="12" v-if="form.point_type==238">
          <el-form-item
            label="信号名称"
            prop="signal_name"
            :rules="{ message: '请填写/选择', trigger: 'blur', required: true }"
          >
            <el-select v-model="form.signal_name">
                <el-option v-for="(item,index) in paiList" :key="index" :value="item" :label="item">{{item}} </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item label="部位号" prop="number" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="部位名称" prop="true_addr" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.true_addr"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="设备名称" prop="device_name" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }">
            <el-input v-model="form.device_name"></el-input>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="x坐标" prop="x_axis ">
            <el-input v-model="form.x_axis"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="y坐标" prop="y_axis">
            <el-input v-model="form.y_axis"></el-input>
          </el-form-item>
        </el-col> -->

        <el-col :span="24" style="overflow:auto" v-if="!(form.point_type == 238)">
          <el-form-item label-width="180px" prop="point_video " style="overflow:auto">
            <!-- <el-input v-model="form.point_video"></el-input> -->
            <span class="" slot="label">
              点位视频
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="plus"></el-button>
              <el-button type="danger" size="mini" icon="el-icon-minus" @click="plus(0)"></el-button>
            </span>
            <el-col :span="8" v-for="(item, index) in videoValue" :key="index">
              <el-select v-model="item.video" style="margin-bottom:10px">
                <el-option :value="it.v_video_ip" :label="it.v_video_address" v-for="(it, ind) in videoList" :key="ind">{{ it.v_video_address }}</el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-col>
        <el-col :span="20">
          <el-form-item label="备注" prop="point_remark">
            <el-input v-model="form.point_remark" type="textarea"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="btn-box center">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button type="primary" class=" ml20" @click="$router.back()">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
// import getLoation from './getLoation'
import vselect from '@/components/v-select';
export default {
  components: { vselect },
  data() {
    return {
      form: {
        area_uuid: this.$route.query.area_uuid,
        point_type: '', //点位类型
        system_type: 0, //系统类型
        point_video: '', //视频
        number: '', //部位好
        true_addr: '', // 真是i地址
        device_name: '', //设备名车
        x_axis: '',
        xa_axis: '',
        signal_name: '',
        ya_axis: '',
        y_axis: '',
        point_remark: '', //备注
      },
      fileList: [],
      paiList: [], //设备列表
      videoList: [],
      videoValue: [
        {
          video: '',
        },
      ],
      units: [],
      // infoOpts:["水位","水压","电气火灾监控设备","用户信息传输装置","无线烟感","RTU","其他"],

      rules: {},
    };
  },
  created() {
    this.$post('/devicemanage/selectconpanybyme', {
      c_belong_profession: 174,
    }).then((res) => {
      this.units = res.data;
    });

    this.$post('/monitor/videowar', { c_company_num: this.$route.query.c_num }).then((res) => {
      this.videoList = res.data;
    });

    // this.$get(`/crt/crtMachineNo/${this.$route.query.c_num}`).then(res=>{
    //     console.log(res)
    //     this.paiList = res.dataCD呃呃呃32
    // })
    if (this.$route.query.id) {
      this.$post(`/crt/crtdetail/${this.$route.query.id}`).then((res) => {
        this.form = { ...this.form, ...res.data };
        this.changeArr();
      });
    }
  },
  methods: {
    getLoa(val) {
      this.form.lon = val[0];
      this.form.lat = val[1];
    },
    plus(a) {
      if (a) {
        if (this.videoValue.length > 5) {
          this.$message.warning('每个点位最多添加五个视频设备');
          return;
        }
        this.videoValue.push({ video: '' });
      } else {
        if (this.videoValue.length <= 1) {
          return;
        }
        this.videoValue.splice(this.videoValue.length - 1, 1);
      }
    },
    uploadSuccess(res, file, fileList) {
      var arr = [];
      fileList.forEach((it) => {
        if (it.response) {
          arr.push(...it.response.image_uuid);
        } else if (it.url) {
          arr.push(it.url);
        }
      });
      this.fileList = [];
      arr.forEach((it, index) => {
        this.fileList.push({ name: '附件' + (index + 1), url: it });
      });
      this.form.picname = arr;
    },
    removeFile(file, fileList) {
      var arr = [];
      fileList.forEach((it) => {
        arr.push(it.url);
      });
      this.fileList = [];
      arr.forEach((it, index) => {
        this.fileList.push({ name: '附件' + (index + 1), url: it });
      });
      this.form.picname = arr;
    },
    onSubmit() {
      this.changeString();
      this.$refs.form.validate((valid) => {
        if (valid) {
          //   return;
          this.save();
        } else {
          return false;
        }
      });
    },
    changeString() {
      var str = '';
      this.videoValue.map((item) => {
        str += ',' + item.video;
      });
      this.form.point_video = str.substr(1);
    },
    changeArr() {
      var arr = [];
      // console.log(this.form);
      var arr1 = this.form.point_video.split(',');
      arr1.map((it) => {
        var obj = { video: it };

        arr.push(obj);
      });
      this.videoValue = arr;
    },
    save() {
      let loading = this.$loading({ background: 'rgba(0, 0, 0, 0.6)' });
      let api = this.$route.query.id ? '/crt/crtupdate' : '/crt/crtinsert';
      this.$post(api, this.form)
        .then((res) => {
          // this.$message.success('保存成功');
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          this.$router.back();
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped></style>
